<!-- ============================ HERO ============================ -->
<section class="ds-hero">
  <div class="ds-orb ds-orb--soft ds-hero__orb-1"></div>
  <div class="ds-orb ds-orb--cobalt ds-hero__orb-2"></div>

  <div class="container ds-hero__inner">
    <div class="row align-items-center g-5">
      <div class="col-lg-7 ds-hero__copy ds-enter">
        <span class="ds-pill">Yapay Zeka Asistanı</span>
        <h1>
          E-ticaret için Yapay Zeka Destekli Müşteri Hizmetleri
        </h1>
        <p class="ds-lead mb-4">
          Keyo AI ile müşterilerinize 7/24 kesintisiz destek sunun. Sesli ve yazılı asistan teknolojimiz sayesinde
          müşteri memnuniyetini artırın.
        </p>
        <div class="d-flex flex-wrap gap-3">
          <a routerLink="/contact" fragment="contact-form" class="btn btn-primary btn-lg">Demo Talep Et</a>
          <a routerLink="/how-it-works" class="btn btn-outline-primary btn-lg">Nasıl Çalışır?</a>
        </div>
        <div class="ds-hero__trust">
          <div class="ds-hero__trust-dots"><span></span><span></span><span></span></div>
          <p>50+ e-ticaret sitesi tarafından tercih ediliyor</p>
        </div>
      </div>
      <div class="col-lg-5 ds-enter-panel">
        <div class="ds-panel ds-hero__panel">
          <div class="ds-frame">
            <div class="ds-frame__chrome"><span></span><span></span><span></span></div>
            <div class="ds-frame__body ds-hero-chat" aria-hidden="true">
              <div class="ds-hero-chat__bubble ai a">Merhaba! Size nasıl yardımcı olabilirim?</div>
              <div class="ds-hero-chat__bubble user b">Ürün stokta var mı?</div>
              <div class="ds-hero-chat__bubble ai c">Evet, ürün stokta mevcut. Hemen sipariş verebilirsiniz.</div>

              <div class="ds-hero-chat__avatar">
                <svg viewBox="0 0 32 32" width="28" height="28" fill="none" stroke="currentColor" stroke-width="2.2"
                  stroke-linecap="round" stroke-linejoin="round">
                  <circle cx="11" cy="13" r="1.2" fill="currentColor" />
                  <circle cx="21" cy="13" r="1.2" fill="currentColor" />
                  <path d="M10 19c1.5 2 3.5 3 6 3s4.5-1 6-3" />
                </svg>
              </div>

              <div class="ds-hero-chat__typing">
                <span></span><span></span><span></span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- ============================ STATS STRIP ============================ -->
<section class="ds-stats">
  <div class="container">
    <div class="ds-stats__grid">
      <div class="ds-stats__item">
        <h3>50+</h3>
        <p>Aktif Müşteri</p>
      </div>
      <div class="ds-stats__divider"></div>
      <div class="ds-stats__item">
        <h3>1M+</h3>
        <p>Aylık Etkileşim</p>
      </div>
      <div class="ds-stats__divider"></div>
      <div class="ds-stats__item">
        <h3>%99.9</h3>
        <p>Uptime</p>
      </div>
      <div class="ds-stats__divider"></div>
      <div class="ds-stats__item">
        <h3>%95+</h3>
        <p>Müşteri Memnuniyeti</p>
      </div>
    </div>
  </div>
</section>

<!-- ============================ HOW IT WORKS — list LEFT, visual RIGHT ============================ -->
<section class="ds-section ds-hiw">
  <div class="container">
    <!-- TOP: title left, description right -->
    <div class="row g-4 ds-hiw__head">
      <div class="col-lg-6">
        <span class="ds-pill">Nasıl Çalışır</span>
        <h2>E-ticaret için Eğitilmiş Yapay Zeka Asistanı</h2>
      </div>
      <div class="col-lg-6 ds-hiw__head-text">
        <p class="ds-lead">
          Keyo AI ile müşterileriniz sorunlarına etkili yanıtlar bulur, sipariş takibi yapar ve aksiyon alır. Hepsi tek
          bir akış içinde.
        </p>
      </div>
    </div>

    <!-- BOTTOM: stepper LEFT, visual RIGHT — equal heights -->
    <div class="row align-items-stretch g-4 ds-hiw__body">
      <div class="col-lg-6 d-flex">
        <div class="ds-stepper">
          <button *ngFor="let step of hiwSteps; let i = index" type="button" class="ds-stepper__item"
            [class.is-active]="activeHiw === i" (click)="selectHiw(i)">
            <span class="ds-stepper__num">{{ step.num }}</span>
            <div class="ds-stepper__body">
              <h3>{{ step.title }}</h3>
              <p>{{ step.body }}</p>
            </div>
          </button>
        </div>
      </div>

      <div class="col-lg-6 d-flex">
        <div class="ds-hiw__visual">
          <!-- 01 — GTM tag → live site widget -->
          <div class="ds-mock" [class.is-active]="activeHiw === 0">
            <div class="ds-mock__panel ds-mock__integrate">
              <div class="ds-mock__panel-head">
                <h4>
                  <span class="ds-mock__gtm-mark">G</span>
                  Tag Manager &middot; GTM-K8YO
                </h4>
                <span class="ds-mock__chip ds-mock__chip--live"><span class="dot"></span> Yayında</span>
              </div>

              <div class="ds-mock__gtm-list">
                <div class="ds-mock__gtm-tag is-keyo">
                  <div class="ds-mock__gtm-tag-icon ds-mock__gtm-tag-icon--cobalt">
                    <i class="fas fa-comment-dots"></i>
                  </div>
                  <div class="ds-mock__gtm-tag-body">
                    <strong>Keyo AI Widget</strong>
                    <span>Custom HTML &middot; All Pages</span>
                  </div>
                  <i class="fas fa-check-circle ds-mock__gtm-tag-ok"></i>
                </div>
              </div>

              <div class="ds-mock__integrate-flow" aria-hidden="true">
                <div class="ds-mock__integrate-flow-track">
                  <span class="ds-mock__integrate-flow-dot"></span>
                </div>
                <i class="fas fa-arrow-down ds-mock__integrate-flow-arrow"></i>
              </div>

              <div class="ds-mock__integrate-site">
                <div class="ds-mock__integrate-site-chrome">
                  <span class="dot"></span><span class="dot"></span><span class="dot"></span>
                  <span class="ds-mock__integrate-site-url">
                    <i class="fas fa-lock"></i> magazaniz.com
                  </span>
                </div>
                <div class="ds-mock__integrate-site-body">
                  <div class="ds-mock__integrate-site-skel lg"></div>
                  <div class="ds-mock__integrate-site-skel md"></div>
                  <div class="ds-mock__integrate-site-skel sm"></div>
                  <div class="ds-mock__integrate-widget" aria-hidden="true">
                    <i class="fas fa-comment-dots"></i>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- 02 — Data Sources -->
          <div class="ds-mock" [class.is-active]="activeHiw === 1">
            <div class="ds-mock__panel ds-mock__data">
              <div class="ds-mock__panel-head">
                <h4>Veri Kaynakları</h4>
              </div>
              <ul class="ds-mock__list">
                <li>
                  <span class="ds-mock__list-icon"><i class="fas fa-box"></i></span>
                  <div><strong>Ürün Kataloğu</strong></div>
                  <i class="fas fa-check-circle ds-mock__list-ok"></i>
                </li>
                <li>
                  <span class="ds-mock__list-icon"><i class="fas fa-question-circle"></i></span>
                  <div><strong>SSS Dokümanları</strong></div>
                  <i class="fas fa-check-circle ds-mock__list-ok"></i>
                </li>
                <li>
                  <span class="ds-mock__list-icon"><i class="fas fa-building"></i></span>
                  <div><strong>Marka Hakkında Bilgiler</strong></div>
                  <i class="fas fa-check-circle ds-mock__list-ok"></i>
                </li>
              </ul>
            </div>
          </div>

          <!-- 03 — Voice Agent (ElevenLabs-style click-to-call demo) -->
          <div class="ds-mock" [class.is-active]="activeHiw === 2">
            <div class="ds-mock__panel ds-mock__voice">
              <div class="ds-mock__voice-head">
                <div class="ds-mock__voice-avatar">K</div>
                <div class="ds-mock__voice-title">
                  <strong>Sesli Asistan</strong>
                  <span>Yardıma hazır</span>
                </div>
                <div class="ds-mock__voice-actions" aria-hidden="true">
                  <span class="ds-mock__voice-action"><i class="fas fa-ellipsis-h"></i></span>
                  <span class="ds-mock__voice-action ds-mock__voice-action--call"><i class="fas fa-phone"></i></span>
                </div>
              </div>

              <div class="ds-mock__voice-stage" aria-hidden="true">
                <!-- Decorative cobalt conic-gradient orb behind dial (continuously spinning) -->
                <div class="ds-mock__voice-orb"></div>

                <!-- Audio bars (visible during Listening / Speaking) -->
                <div class="ds-mock__voice-bars">
                  <span></span><span></span><span></span><span></span><span></span>
                </div>

                <!-- Dial button: phone (idle) → phone-slash (call active) -->
                <div class="ds-mock__voice-dial">
                  <i class="fas fa-phone ds-mock__voice-dial-call"></i>
                  <i class="fas fa-phone-slash ds-mock__voice-dial-hangup"></i>
                </div>

                <!-- Status states stacked, only one visible at a time -->
                <div class="ds-mock__voice-status ds-mock__voice-status--idle">
                  <strong>Aramayı başlat</strong>
                </div>
                <div class="ds-mock__voice-status ds-mock__voice-status--listening">
                  <strong>Dinleniyor…</strong>
                  <span>Ses girişi işleniyor</span>
                </div>
                <div class="ds-mock__voice-status ds-mock__voice-status--speaking">
                  <strong>Konuşuyor…</strong>
                  <span>Asistan yanıtlıyor</span>
                </div>

                <!-- Animated mouse cursor (idle → moves to dial → clicks → fades) -->
                <div class="ds-mock__voice-cursor">
                  <svg viewBox="0 0 16 16" width="14" height="14">
                    <path d="M2 2 L2 14 L6 10 L8.5 14.5 L10.5 13.5 L8 9 L13 9 Z"
                      fill="#1a1a1a" stroke="white" stroke-width="0.6" stroke-linejoin="round" />
                  </svg>
                </div>
              </div>
            </div>
          </div>

          <!-- 04 — Destek Talebine Otomatik Geçiş — chat → ticket created → status flips New→Solved -->
          <div class="ds-mock" [class.is-active]="activeHiw === 3">
            <div class="ds-mock__panel ds-mock__support">
              <div class="ds-mock__support-chat" aria-hidden="true">
                <div class="ds-mock__support-bubble user a">
                  Aynı gün teslimat olması gereken siparişim halen bana ulaşmadı.
                </div>

                <div class="ds-mock__support-typing">
                  <span></span><span></span><span></span>
                </div>

                <div class="ds-mock__support-bubble ai b">
                  Merhaba, yaşadığınız bu durum için üzgün olduğumuzu belirtmek isteriz. Destek talebiniz başarıyla oluşturuldu. Ekibimiz en kısa sürede size dönüş yapacaktır.
                </div>

                <div class="ds-mock__support-bubble user c">Teşekkürler</div>
              </div>

              <div class="ds-mock__support-ticket" aria-hidden="true">
                <div class="ds-mock__support-ticket-head">
                  <h5>Destek Talebi Özeti</h5>
                  <div class="ds-mock__support-status">
                    <span class="ds-mock__support-status-pill ds-mock__support-status-pill--new">
                      <i class="fas fa-circle"></i> New
                    </span>
                    <span class="ds-mock__support-status-pill ds-mock__support-status-pill--solved">
                      <i class="fas fa-check-circle"></i> Solved
                    </span>
                  </div>
                </div>
                <div class="ds-mock__support-ticket-body">
                  <div class="ds-mock__support-ticket-row">
                    <span>Müşteri</span><strong>Ayşe Demir</strong>
                  </div>
                  <div class="ds-mock__support-ticket-row">
                    <span>Talep</span><strong>Aynı gün teslimat siparişi ulaşmadı</strong>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- 05 — AI Rapor Asistanı — query → typing → answer → metrics → chart bars -->
          <div class="ds-mock" [class.is-active]="activeHiw === 4">
            <div class="ds-mock__panel ds-mock__report">
              <div class="ds-mock__panel-head">
                <h4><i class="fas fa-sparkles" style="color: var(--ds-cobalt); margin-right: 6px;"></i> AI Rapor
                  Asistanı</h4>
              </div>
              <div class="ds-mock__bubble user" style="font-size: 13.5px;">"Bu hafta en sık tekrarlayan müşteri
                şikayetleri neler?"</div>

              <div class="ds-mock__report-typing" aria-hidden="true">
                <span></span><span></span><span></span>
              </div>

              <div class="ds-mock__bubble ai" style="font-size: 13.5px;">
                Toplam <strong>147 şikayetin</strong> dağılımı:
              </div>
              <div class="ds-mock__metrics" style="grid-template-columns: repeat(3, 1fr); gap: 6px;">
                <div>
                  <span class="ds-mock__metric-num">%42</span>
                  <span class="ds-mock__metric-lbl">Kargo gecikme</span>
                </div>
                <div>
                  <span class="ds-mock__metric-num">%31</span>
                  <span class="ds-mock__metric-lbl">Hasarlı ürün</span>
                </div>
                <div>
                  <span class="ds-mock__metric-num">%18</span>
                  <span class="ds-mock__metric-lbl">İade süreci</span>
                </div>
              </div>
              <div class="ds-mock__chart">
                <div style="height:32%"></div>
                <div style="height:48%"></div>
                <div style="height:62%"></div>
                <div style="height:55%"></div>
                <div style="height:78%"></div>
                <div style="height:84%"></div>
                <div style="height:92%"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- ============================ FEATURES (glassmorphism) ============================ -->
<section class="ds-section ds-features">
  <!-- decorative orbs that show through the glass cards -->
  <div class="ds-orb ds-orb--cobalt ds-features__orb-1"></div>
  <div class="ds-orb ds-orb--soft   ds-features__orb-2"></div>
  <div class="ds-orb ds-orb--midnight ds-features__orb-3"></div>

  <div class="container ds-features__inner">
    <div class="text-center ds-features__head">
      <span class="ds-pill">Öne Çıkanlar</span>
      <h2>Neden Keyo AI?</h2>
      <p class="ds-lead">E-ticaret siteniz için en iyi yapay zeka çözümü</p>
    </div>

    <div class="row g-4 ds-features__grid">
      <!-- Voice Agent — featured (cobalt outline emphasis) -->
      <div class="col-md-6 col-lg-4">
        <div class="ds-feature ds-feature--cobalt ds-feature--featured" (mousemove)="onFeatureMove($event)"
          (mouseleave)="onFeatureLeave($event)">
          <div class="ds-feature__icon"><i class="fas fa-microphone-alt"></i></div>
          <h3>Voice Agent</h3>
          <p>Müşterileriniz sesli komutlarla ürün arar, fiyat karşılaştırır ve destek talep eder. Telefon konuşması
            doğallığında, 7/24 erişilebilir.</p>
        </div>
      </div>
      <div class="col-md-6 col-lg-4">
        <div class="ds-feature ds-feature--soft" (mousemove)="onFeatureMove($event)"
          (mouseleave)="onFeatureLeave($event)">
          <div class="ds-feature__icon"><i class="fas fa-robot"></i></div>
          <h3>Akıllı Yazılı Asistan</h3>
          <p>Müşterilerin sorularını anlar, ürün detayları sunan kart akışıyla yanıtlar.
          </p>
        </div>
      </div>
      <div class="col-md-6 col-lg-4">
        <div class="ds-feature ds-feature--midnight" (mousemove)="onFeatureMove($event)"
          (mouseleave)="onFeatureLeave($event)">
          <div class="ds-feature__icon"><i class="fas fa-chart-line"></i></div>
          <h3>AI Rapor Asistanı</h3>
          <p>Konuşma verilerinizi yapay zekaya sorarak en sık şikayet konuları, ürün talebi ve performans içgörüleri
            elde edin.</p>
        </div>
      </div>
      <div class="col-md-6 col-lg-4">
        <div class="ds-feature ds-feature--soft" (mousemove)="onFeatureMove($event)"
          (mouseleave)="onFeatureLeave($event)">
          <div class="ds-feature__icon"><i class="fas fa-code"></i></div>
          <h3>Kolay Entegrasyon</h3>
          <p>Google Tag Manager (GTM) üzerinden dakikalar içinde kurun. Tüm e-ticaret platformlarıyla
            uyumlu.</p>
        </div>
      </div>
      <div class="col-md-6 col-lg-4">
        <div class="ds-feature ds-feature--midnight" (mousemove)="onFeatureMove($event)"
          (mouseleave)="onFeatureLeave($event)">
          <div class="ds-feature__icon"><i class="fas fa-shield-alt"></i></div>
          <h3>Güvenli Altyapı</h3>
          <p>KVKK ve GDPR uyumlu, uçtan uca şifreli güvenli altyapı ile verileriniz güvende.</p>
        </div>
      </div>
      <div class="col-md-6 col-lg-4">
        <div class="ds-feature ds-feature--cobalt" (mousemove)="onFeatureMove($event)"
          (mouseleave)="onFeatureLeave($event)">
          <div class="ds-feature__icon"><i class="fas fa-headset"></i></div>
          <h3>7/24 Destek</h3>
          <p>Teknik ekibimiz 7/24 yanınızda. Kurulum ve kullanım sürecinde ihtiyacınız olan her an destek alın.</p>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- ============================ BENEFITS — visual LEFT, list RIGHT ============================ -->
<section class="ds-section ds-benefits">
  <div class="container">
    <!-- TOP: title left, description right -->
    <div class="row g-4 ds-benefits__head">
      <div class="col-lg-6">
        <span class="ds-pill">Sonuçlar</span>
        <h2>7/24 Kesintisiz Müşteri Deneyimi</h2>
      </div>
      <div class="col-lg-6 ds-benefits__head-text">
        <p class="ds-lead">
          Keyo AI sadece bir sohbet botu değil, markanız adına aksiyon alan, müşterinizi tanıyan ve gerektiğinde insana
          devreden bir takım arkadaşı.
        </p>
      </div>
    </div>

    <!-- BOTTOM: visual LEFT, stepper RIGHT — equal heights -->
    <div class="row align-items-stretch g-4 ds-benefits__body">
      <div class="col-lg-6 d-flex">
        <div class="ds-benefits__visual">
          <!-- 0 — Voice Agent (NEW, featured) — bubbles reveal one by one, waveform animates -->
          <div class="ds-mock" [class.is-active]="activeBenefit === 0">
            <div class="ds-mock__panel ds-mock__chat ds-mock__voice-bench">
              <div class="ds-mock__panel-head">
                <h4><i class="fas fa-microphone-alt" style="color: var(--ds-cobalt); margin-right: 6px;"></i> Voice
                  Agent · Canlı</h4>
                <span class="ds-mock__chip ds-mock__chip--live"><span class="dot"></span> 00:42</span>
              </div>
              <div class="ds-mock__voice-wave" aria-hidden="true">
                <span></span><span></span><span></span><span></span><span></span>
                <span></span><span></span><span></span><span></span><span></span>
                <span></span><span></span><span></span>
              </div>
              <div class="ds-mock__bubble user a"><i class="fas fa-microphone"
                  style="opacity: 0.6; margin-right: 4px;"></i> "Ofis için bir yazıcı bakıyorum ama kartuş maliyeti
                düşük, ekonomik bir model olsun istiyorum."</div>
              <div class="ds-mock__bubble ai b">
                Hemen yardımcı olayım. Kullanım yoğunluğunuza göre tanklı modellerimiz sayfa başı maliyette çok daha
                tasarrufludur. Şu an en çok tercih edilen X modeli 4.200 TL, daha yüksek kapasiteli Y modeli ise
                5.500 TL. Şu an bu modellerde sepette %10 indirim de var.
              </div>
              <div class="ds-mock__bubble user c"><i class="fas fa-microphone"
                  style="opacity: 0.6; margin-right: 4px;"></i> "Peki bunların garanti süreleri ne kadar?"</div>
              <div class="ds-mock__bubble ai d">
                Her iki model de 2 yıl resmi distribütör garantilidir.
              </div>
            </div>
          </div>

          <!-- 1 — Müşteri Hizmetleri Maliyetini Düşürün — abstract declining bars + 3 concept icons -->
          <div class="ds-mock" [class.is-active]="activeBenefit === 1">
            <div class="ds-mock__panel ds-mock__cost">
              <div class="ds-mock__panel-head">
                <h4><i class="fas fa-chart-line" style="color: var(--ds-cobalt); margin-right: 6px;"></i> Maliyet Düşüşü
                </h4>
              </div>

              <div class="ds-mock__cost-trend-row" aria-hidden="true">
                <i class="fas fa-arrow-trend-down ds-mock__cost-trend-arrow"></i>
                <div class="ds-mock__cost-bars">
                  <div></div>
                  <div></div>
                  <div></div>
                  <div></div>
                  <div></div>
                  <div></div>
                </div>
              </div>

              <div class="ds-mock__cost-stats" aria-hidden="true">
                <div class="ds-mock__cost-stat">
                  <i class="fas fa-clock"></i>
                  <span>7/24 Otomatik</span>
                </div>
                <div class="ds-mock__cost-stat">
                  <i class="fas fa-arrow-down"></i>
                  <span>Düşük Maliyet</span>
                </div>
                <div class="ds-mock__cost-stat">
                  <i class="fas fa-users"></i>
                  <span>Az İK Yükü</span>
                </div>
              </div>
            </div>
          </div>

          <!-- 2 — Çok Kanallı Destek — 4 channel cards (Web Chatbot / WhatsApp / Instagram / Facebook) -->
          <div class="ds-mock" [class.is-active]="activeBenefit === 2">
            <div class="ds-mock__panel ds-mock__channels">
              <div class="ds-mock__panel-head">
                <h4><i class="fas fa-share-nodes" style="color: var(--ds-cobalt); margin-right: 6px;"></i> Çok Kanallı
                  Destek</h4>
                <span class="ds-mock__chip ds-mock__chip--live"><span class="dot"></span> Bağlı</span>
              </div>

              <div class="ds-mock__channels-grid" aria-hidden="true">
                <div class="ds-mock__channel ds-mock__channel--web">
                  <div class="ds-mock__channel-icon"><i class="fas fa-comment-dots"></i></div>
                  <div class="ds-mock__channel-name">Website Chatbot</div>
                  <div class="ds-mock__channel-status"><span class="dot"></span> Aktif</div>
                </div>
                <div class="ds-mock__channel ds-mock__channel--whatsapp">
                  <div class="ds-mock__channel-icon"><i class="fab fa-whatsapp"></i></div>
                  <div class="ds-mock__channel-name">WhatsApp</div>
                  <div class="ds-mock__channel-status"><span class="dot"></span> Aktif</div>
                </div>
                <div class="ds-mock__channel ds-mock__channel--instagram">
                  <div class="ds-mock__channel-icon"><i class="fab fa-instagram"></i></div>
                  <div class="ds-mock__channel-name">Instagram</div>
                  <div class="ds-mock__channel-status"><span class="dot"></span> Aktif</div>
                </div>
                <div class="ds-mock__channel ds-mock__channel--facebook">
                  <div class="ds-mock__channel-icon"><i class="fab fa-facebook-f"></i></div>
                  <div class="ds-mock__channel-name">Facebook</div>
                  <div class="ds-mock__channel-status"><span class="dot"></span> Aktif</div>
                </div>
              </div>
            </div>
          </div>

          <!-- 3 — Merkezi Yönetim Paneli — 3 module cards (Konuşmalar / Müşteriler / Talepler) -->
          <div class="ds-mock" [class.is-active]="activeBenefit === 3">
            <div class="ds-mock__panel ds-mock__admin">
              <div class="ds-mock__panel-head">
                <h4><i class="fas fa-th-large" style="color: var(--ds-cobalt); margin-right: 6px;"></i> Yönetim Paneli
                </h4>
                <span class="ds-mock__chip ds-mock__chip--live"><span class="dot"></span> Canlı</span>
              </div>

              <div class="ds-mock__admin-modules" aria-hidden="true">
                <div class="ds-mock__admin-module">
                  <div class="ds-mock__admin-module-icon"><i class="fas fa-comments"></i></div>
                  <div class="ds-mock__admin-module-body">
                    <strong>Konuşma Geçmişi</strong>
                    <span>Tüm görüşmeler tek yerde</span>
                  </div>
                  <i class="fas fa-chevron-right ds-mock__admin-module-chevron"></i>
                </div>
                <div class="ds-mock__admin-module">
                  <div class="ds-mock__admin-module-icon"><i class="fas fa-users"></i></div>
                  <div class="ds-mock__admin-module-body">
                    <strong>Müşteri Listesi</strong>
                    <span>Aktif müşterileriniz</span>
                  </div>
                  <i class="fas fa-chevron-right ds-mock__admin-module-chevron"></i>
                </div>
                <div class="ds-mock__admin-module">
                  <div class="ds-mock__admin-module-icon"><i class="fas fa-ticket-alt"></i></div>
                  <div class="ds-mock__admin-module-body">
                    <strong>Destek Talepleri</strong>
                    <span>Açık talepler ve durumlar</span>
                  </div>
                  <i class="fas fa-chevron-right ds-mock__admin-module-chevron"></i>
                </div>
              </div>
            </div>
          </div>

          <!-- 4 — Veri Odaklı Karar Alın — 3 mini reports (donut + h-bars + trend bars) -->
          <div class="ds-mock" [class.is-active]="activeBenefit === 4">
            <div class="ds-mock__panel ds-mock__insights">
              <div class="ds-mock__panel-head">
                <h4><i class="fas fa-chart-pie" style="color: var(--ds-cobalt); margin-right: 6px;"></i> Veri Raporu
                </h4>
                <span class="ds-mock__chip ds-mock__chip--live"><span class="dot"></span> Canlı</span>
              </div>

              <div class="ds-mock__insights-grid" aria-hidden="true">
                <div class="ds-mock__insights-card">
                  <div class="ds-mock__insights-card-head">
                    <i class="fas fa-exclamation-circle"></i>
                    <strong>Şikayet Konuları</strong>
                  </div>
                  <div class="ds-mock__insights-donut"></div>
                </div>

                <div class="ds-mock__insights-card">
                  <div class="ds-mock__insights-card-head">
                    <i class="fas fa-question-circle"></i>
                    <strong>Sık Sorulan</strong>
                  </div>
                  <div class="ds-mock__insights-bars-h">
                    <div class="ds-mock__insights-bar-h" style="--w: 82%"></div>
                    <div class="ds-mock__insights-bar-h" style="--w: 60%"></div>
                    <div class="ds-mock__insights-bar-h" style="--w: 38%"></div>
                  </div>
                </div>

                <div class="ds-mock__insights-card ds-mock__insights-card--wide">
                  <div class="ds-mock__insights-card-head">
                    <i class="fas fa-chart-line"></i>
                    <strong>Destek Yükü</strong>
                  </div>
                  <div class="ds-mock__insights-trend">
                    <div style="height: 35%"></div>
                    <div style="height: 55%"></div>
                    <div style="height: 45%"></div>
                    <div style="height: 70%"></div>
                    <div style="height: 60%"></div>
                    <div style="height: 85%"></div>
                    <div style="height: 75%"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-lg-6 d-flex">
        <div class="ds-stepper">
          <button *ngFor="let item of benefitItems; let i = index" type="button"
            class="ds-stepper__item ds-stepper__item--no-num" [class.is-active]="activeBenefit === i"
            (click)="selectBenefit(i)">
            <div class="ds-stepper__body">
              <h3>{{ item.title }}</h3>
              <p>{{ item.body }}</p>
            </div>
          </button>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- ============================ PRICING ============================ -->
<section class="ds-section ds-pricing">
  <div class="container">
    <div class="text-center ds-pricing__head">
      <span class="ds-pill">Paketler</span>
      <h2>Size Uygun Paketi Seçin</h2>
      <p class="ds-lead">E-ticaret sitenizin büyüklüğüne ve ihtiyaçlarınıza göre en uygun paketi seçebilirsiniz</p>
    </div>
    <div class="row g-4">
      <div class="col-lg-3 col-md-6">
        <div class="price-card">
          <div class="price-header">
            <h4>Starter</h4>
            <p class="price-desc">Küçük mağazalar için temel özellikler.</p>
            <div class="price-value">$24</div>
            <div class="price-period">aylık</div>
          </div>
          <div class="price-features">
            <a routerLink="/contact" fragment="contact-form" class="btn btn-outline-primary d-block mb-4">Demo Talep Et</a>
            <div class="price-includes">İçerir</div>
            <ul>
              <li class="price-quota">1.000 mesajlaşma</li>
              <li class="price-quota">10 dakika konuşma</li>
              <li class="price-quota">1.000 Ürün</li>
              <li>Gelişmiş ürün bilgileri</li>
              <li>Sipariş durumu takibi</li>
              <li>E-posta desteği</li>
              <li>Admin paneli</li>
              <li>Ekstra bilgi yükleyebilme</li>
              <li>Kapsamlı müşteri destek asistanı</li>
              <li>Ticket yönetimi</li>
              <li>Gelişmiş satış asistanı</li>
              <li>Sepet işlemleri</li>
              <li>Gelişmiş AI raporlama</li>
              <li>Instagram AI entegrasyonu</li>
              <li>Facebook AI entegrasyonu</li>
              <li>WhatsApp AI entegrasyonu</li>
              <li>Telegram AI entegrasyonu</li>
              <li>Pazaryeri Entegrasyonu (Trendyol, Hepsiburada, N11, Amazon)</li>
              <li>Özel API bağlantıları</li>
            </ul>
          </div>
        </div>
      </div>
      <div class="col-lg-3 col-md-6">
        <div class="price-card">
          <div class="price-header">
            <h4>Pro</h4>
            <p class="price-desc">Büyüyen işletmeler için en iyi değer.</p>
            <div class="price-value">$74</div>
            <div class="price-period">aylık</div>
          </div>
          <div class="price-features">
            <a routerLink="/contact" fragment="contact-form" class="btn btn-outline-primary d-block mb-4">Demo Talep Et</a>
            <div class="price-includes">İçerir</div>
            <ul>
              <li class="price-quota">3.000 mesajlaşma</li>
              <li class="price-quota">30 dakika konuşma</li>
              <li class="price-quota">10.000 Ürün</li>
              <li>Gelişmiş ürün bilgileri</li>
              <li>Sipariş durumu takibi</li>
              <li>E-posta desteği</li>
              <li>Admin paneli</li>
              <li>Ekstra bilgi yükleyebilme</li>
              <li>Kapsamlı müşteri destek asistanı</li>
              <li>Ticket yönetimi</li>
              <li>Gelişmiş satış asistanı</li>
              <li>Sepet işlemleri</li>
              <li>Gelişmiş AI raporlama</li>
              <li>Instagram AI entegrasyonu</li>
              <li>Facebook AI entegrasyonu</li>
              <li>WhatsApp AI entegrasyonu</li>
              <li>Telegram AI entegrasyonu</li>
              <li>Pazaryeri Entegrasyonu (Trendyol, Hepsiburada, N11, Amazon)</li>
              <li>Özel API bağlantıları</li>
            </ul>
          </div>
        </div>
      </div>
      <div class="col-lg-3 col-md-6">
        <div class="price-card">
          <div class="price-header">
            <h4>Enterprise</h4>
            <p class="price-desc">Büyük ölçek için maksimum güç.</p>
            <div class="price-value">$244</div>
            <div class="price-period">aylık</div>
          </div>
          <div class="price-features">
            <a routerLink="/contact" fragment="contact-form" class="btn btn-outline-primary d-block mb-4">Demo Talep Et</a>
            <div class="price-includes">İçerir</div>
            <ul>
              <li class="price-quota">10.000 mesajlaşma</li>
              <li class="price-quota">90 dakika konuşma</li>
              <li class="price-quota">25.000 Ürün</li>
              <li>Gelişmiş ürün bilgileri</li>
              <li>Sipariş durumu takibi</li>
              <li>E-posta desteği</li>
              <li>Admin paneli</li>
              <li>Ekstra bilgi yükleyebilme</li>
              <li>Kapsamlı müşteri destek asistanı</li>
              <li>Ticket yönetimi</li>
              <li>Gelişmiş satış asistanı</li>
              <li>Sepet işlemleri</li>
              <li>Gelişmiş AI raporlama</li>
              <li>Instagram AI entegrasyonu</li>
              <li>Facebook AI entegrasyonu</li>
              <li>WhatsApp AI entegrasyonu</li>
              <li>Telegram AI entegrasyonu</li>
              <li>Pazaryeri Entegrasyonu (Trendyol, Hepsiburada, N11, Amazon)</li>
              <li>Özel API bağlantıları</li>
            </ul>
          </div>
        </div>
      </div>
      <div class="col-lg-3 col-md-6">
        <div class="price-card">
          <div class="price-header">
            <h4>Custom</h4>
            <p class="price-desc">Ölçeğinize ve iş akışlarınıza göre özelleştirilir.</p>
            <div class="price-value">Özel</div>
            <div class="price-period">fiyatlandırma</div>
          </div>
          <div class="price-features">
            <a routerLink="/contact" fragment="contact-form" class="btn btn-outline-primary d-block mb-4">İletişime Geçin</a>
            <div class="price-includes">İçerir</div>
            <ul>
              <li class="price-quota">Sınırsız mesajlaşma</li>
              <li class="price-quota">Sınırsız konuşma</li>
              <li class="price-quota">Sınırsız Ürün</li>
              <li>Gelişmiş ürün bilgileri</li>
              <li>Sipariş durumu takibi</li>
              <li>E-posta desteği</li>
              <li>Admin paneli</li>
              <li>Ekstra bilgi yükleyebilme</li>
              <li>Kapsamlı müşteri destek asistanı</li>
              <li>Ticket yönetimi</li>
              <li>Gelişmiş satış asistanı</li>
              <li>Sepet işlemleri</li>
              <li>Gelişmiş AI raporlama</li>
              <li>Instagram AI entegrasyonu</li>
              <li>Facebook AI entegrasyonu</li>
              <li>WhatsApp AI entegrasyonu</li>
              <li>Telegram AI entegrasyonu</li>
              <li>Pazaryeri Entegrasyonu (Trendyol, Hepsiburada, N11, Amazon)</li>
              <li>Özel API bağlantıları</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <!-- ===== Add-on packages ===== -->
    <div class="ds-addons">
      <div class="ds-addons__head">
        <span class="ds-pill">Ek Paketler</span>
        <h3>Mevcut Paketinizi Genişletin</h3>
        <p>Sosyal medya kanallarınıza Keyo AI entegrasyonu ekleyin.</p>
      </div>

      <div class="ds-addons__list">
        <div class="ds-addon">
          <div class="ds-addon__icon ds-addon__icon--message">
            <i class="fas fa-comment-dots"></i>
          </div>
          <div class="ds-addon__body">
            <h4>Ekstra 1000 AI mesajı</h4>
            <p>Paketinizin mesaj limitini 1.000 AI mesajı ile genişletin.</p>
          </div>
          <div class="ds-addon__price">
            <strong>$40</strong>
            <span>aylık</span>
          </div>
          <a routerLink="/contact" class="btn btn-outline-primary ds-addon__cta">Ekle</a>
        </div>

        <div class="ds-addon">
          <div class="ds-addon__icon ds-addon__icon--voice">
            <i class="fas fa-microphone"></i>
          </div>
          <div class="ds-addon__body">
            <h4>Ekstra 100 dakika konuşma</h4>
            <p>Sesli asistan sürenizi 100 dakika konuşma ile artırın.</p>
          </div>
          <div class="ds-addon__price">
            <strong>$40</strong>
            <span>aylık</span>
          </div>
          <a routerLink="/contact" class="btn btn-outline-primary ds-addon__cta">Ekle</a>
        </div>
      </div>
    </div>

    <div class="text-center mt-5">
      <a routerLink="/contact" class="btn btn-outline-primary">Detaylı Bilgi İçin İletişime Geçin</a>
    </div>
  </div>
</section>

<!-- ============================ CLOSING CTA ============================ -->
<section class="ds-final-cta">
  <div class="container">
    <div class="ds-final-cta__panel">
      <div class="ds-orb ds-orb--soft ds-final-cta__orb"></div>
      <div class="ds-final-cta__content">
        <h2>Müşterilerinize En İyi Deneyimi Yaşatın</h2>
        <p class="ds-lead">Keyo AI ile e-ticaret sitenizi bir adım öne taşıyın. Hemen demo talep edin!</p>
        <a routerLink="/contact" fragment="contact-form" class="btn btn-light btn-lg mt-3">Ücretsiz Demo</a>
      </div>
    </div>
  </div>
</section>